<style scoped>
.br-12 {
  border-radius: 12px;
}
</style>

<template>
  <v-app light padding>
    <v-app-bar fixed app class="primary" dense>
      <v-btn icon @click="navigateBack()" class="white--text" v-if="this.$route.path !== '/'">
        <v-icon>fa-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title class="pointer white--text" v-if="this.$route.path === '/'"><strong>Demo</strong></v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-tooltip bottom style="width: 60px;">
          <template v-slot:activator="{ on, attrs }">
            <v-btn @click="setLocale('cn')" class="white--text hidden-md-and-up" text v-bind="attrs" v-on="on">
              <span class="font-weight-bold">中</span>
            </v-btn>
          </template>
          <span>{{ $t('chinese') }}</span>
        </v-tooltip>
        <v-menu bottom left offset-x v-if="$vuetify.breakpoint.smAndDown" min-width="250">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon color="white" v-bind="attrs" v-on="on">
              <v-icon>fa-ellipsis-v</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click.prevent="$router.push('/')" class="hidden-md-and-up">
              <v-list-item-avatar><v-icon color="primary">fa-home</v-icon></v-list-item-avatar>
              <v-list-item-title>{{ $t('home') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="setLocale('en')" class="hidden-md-and-up">
              <v-list-item-avatar><v-icon color="primary">fa-language</v-icon></v-list-item-avatar>
              <v-list-item-title>English</v-list-item-title>
            </v-list-item>
            <v-list-item @click="setLocale('my')" class="hidden-md-and-up">
              <v-list-item-avatar><v-icon color="primary">fa-language</v-icon></v-list-item-avatar>
              <v-list-item-title>Bahasa Malaysia</v-list-item-title>
            </v-list-item>
            <v-list-item @click="setLocale('cn')" class="hidden-md-and-up">
              <v-list-item-avatar><v-icon color="primary">fa-language</v-icon></v-list-item-avatar>
              <v-list-item-title>中文</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push('/user/form')" class="hidden-md-and-up" v-if="!hasSession">
              <v-list-item-avatar><v-icon color="primary">fa-user-plus</v-icon></v-list-item-avatar>
              <v-list-item-title>{{ $t('sign_up') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="setLoginVisible({ visible: true })" class="hidden-md-and-up" v-if="!hasSession">
              <v-list-item-avatar><v-icon color="primary">fa-sign-in</v-icon></v-list-item-avatar>
              <v-list-item-title>{{ $t('login') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push('/user/detail')" class="hidden-md-and-up" v-if="hasSession">
              <v-list-item-avatar><v-icon color="primary">fa-user-circle</v-icon></v-list-item-avatar>
              <v-list-item-title>{{ $t('my_profile') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="redirect('mptpay-history')" class="hidden-md-and-up" v-if="hasSession">
              <v-list-item-avatar><v-icon color="primary">fa-tasks</v-icon></v-list-item-avatar>
              <v-list-item-title>{{ $t('my_payment_history') }}</v-list-item-title>
            </v-list-item>
            <v-list-item @click="logOut($event)" class="hidden-md-and-up" v-if="hasSession">
              <v-list-item-avatar><v-icon color="primary">fa-power-off</v-icon></v-list-item-avatar>
              <v-list-item-title>{{ $t('logout') }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="white--text hidden-sm-and-down" v-bind="attrs" v-on="on" text large @click="$router.push('/')">
              <v-icon style="font-size: 23px;">fa-home</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('home') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="white--text hidden-sm-and-down" v-bind="attrs" v-on="on" text large @click="setLocale('en')">
              <span class="font-weight-bold">EN</span>
            </v-btn>
          </template>
          <span>{{ $t('english') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="white--text hidden-sm-and-down" v-bind="attrs" v-on="on" text large @click="setLocale('my')">
              <span class="font-weight-bold">BM</span>
            </v-btn>
          </template>
          <span>{{ $t('malay') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="white--text hidden-sm-and-down" v-bind="attrs" v-on="on" text large @click="setLocale('cn')">
              <span class="font-weight-bold">中文</span>
            </v-btn>
          </template>
          <span>{{ $t('chinese') }}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="!hasSession">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="white--text hidden-sm-and-down" v-bind="attrs" v-on="on" text large @click="$router.push('/'); setLoginVisible({ visible: true })">
              <v-icon style="font-size: 23px;">fa-sign-in</v-icon
            ></v-btn>
          </template>
          <span>{{ $t('login') }}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="!hasSession">
          <template v-slot:activator="{ on, attrs }">
          <v-btn class="white--text hidden-sm-and-down" v-bind="attrs" v-on="on"  text large @click="$router.push('/user/form')">
          <v-icon style="font-size: 23px;">fa-user-plus</v-icon
          ></v-btn>
          </template>
          <span>{{ $t('sign_up') }}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="hasSession">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="white--text hidden-sm-and-down" v-bind="attrs" v-on="on" text large @click="logOut($event)">
              <v-icon style="font-size: 23px;">fa-power-off</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('logout') }}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="hasSession">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="white--text hidden-sm-and-down" v-bind="attrs" v-on="on" text large @click="redirect('mptpay-history')">
              <v-icon style="font-size: 23px;">fa-tasks</v-icon
            ></v-btn>
          </template>
          <span>{{ $t('my_payment_history') }}</span>
        </v-tooltip>
        <v-tooltip bottom v-if="hasSession">
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="white--text hidden-sm-and-down" v-bind="attrs" v-on="on" text large @click="$router.push('/user/detail')">
              <v-icon style="font-size: 23px;">fa-user-circle</v-icon
            ></v-btn>
          </template>
          <span>{{ $t('my_profile') }}</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-app-bar>
    <v-main class="mb-10">
      <router-view></router-view>
    </v-main>
    <v-snackbar app :timeout="snackBarState.timeout" :right="snackBarState.right" :bottom="snackBarState.bottom" :color="snackBarState.color" :value="isSnackBarVisible" @input="setSnackBar({color: snackBarState.color, message: '', visible: false})">
      {{ snackBarState.message }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text color="white" @click="setSnackBar({color: snackBarState.color, message: '', visible: false})">OK</v-btn>
      </template>
    </v-snackbar>
    <login-dialog></login-dialog>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-btn x-large v-on="on" fab dark color="primary" fixed right bottom @click="goToChatbot">
          <v-img contain alt="support" max-height="45" max-width="45" src="img/icons/chatbot_icon.png" />
        </v-btn>
      </template>
      <span>{{ $t('chatbot') }}</span>
    </v-tooltip>
  </v-app>
</template>

<script>
  import Vue from 'vue'
  import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
  import LoginDialog from './components/LoginDialog'
  import configuration from './configurations/index'

  export default {
    components: { LoginDialog },
    computed: {
      ...mapGetters({
        hasSession: 'auth/hasSession',
        isSnackBarVisible: 'snackbar/isVisible'
      }),
      ...mapState({
        snackBarState: (state) => state.snackbar
      })
    },
    data () {
      return {
        cordova: Vue.cordova,
        clipped: false,
        drawer: false,
        items: [
          {
            icon: 'home',
            title: 'Home'
          },
          {
            icon: 'dashboard',
            title: 'Categories'
          },
          {
            icon: 'person',
            title: 'Profile'
          },
          {
            icon: 'exit_to_app',
            title: 'Logout'
          }
        ],
        miniVariant: false,
        right: true,
        rightDrawer: false,
        title: 'app_title'
        // title: this.$route.meta.title
      }
    },
    created () {
      var self = this
      this.cordova.on('deviceready', () => {
        self.onDeviceReady()
      })
    },
    methods: {
      ...mapActions({
        authLogIn: 'auth/logIn',
        authLogOut: 'auth/logOut',
        setSnackBar: 'snackbar/setSnackBar'
      }),
      ...mapMutations({
        setLoginVisible: 'dialog/setLoginVisible'
      }),
      goToChatbot () {
        const langs = { en: 'en', my: 'ms', cn: 'zh' }
        const lang = langs[this.$i18n.locale]
        const url = `https://chatbot.mpt.sabahgov.net/${lang}`
        if (!window.hasOwnProperty('cordova')) {
          window.location.href = url
          return
        }
        cordova.InAppBrowser.open(url, '_system', 'location=no,enableViewportScale=yes,zoom=no')
      },
      logOut: async function () {
        await this.authLogOut()
        this.$router.replace({ path: '/' })
      },
      setLocale: function (language) {
        this.$i18n.locale = language
      },
      submitForm: async function () {
        await this.authLogIn(this.data).then(response => {
          if (!response.error) {
            this.resetData()
            // this.$router.replace({ path: '/' })
            this.setLoginVisible({ visible: false })
          } else {
            this.$router.replace({ path: '/' })
            this.setLoginVisible({ visible: true })
          }
        })
      },
      onDeviceReady: function () {
        // Handle the device ready event.
        this.cordova.on('pause', this.onPause, false)
        this.cordova.on('resume', this.onResume, false)
        if (this.cordova.device.platform === 'Android') {
          document.addEventListener('backbutton', this.onBackKeyDown, false)
        }
      },
      onPause () {
        // Handle the pause lifecycle event.
        console.log('pause')
      },
      onResume () {
        // Handle the resume lifecycle event.
        // SetTimeout required for iOS.
        setTimeout(function () {
          console.log('resume')
        }, 0)
      },
      onBackKeyDown () {
        // Handle the back-button event on Android. By default it will exit the app.
        navigator.app.backHistory()
      },
      navigateBack () {
        window.history.go(-1)
      },
      redirect (category) {
        let page
        if (category === 'mptpay-history') {
          page = `${configuration.host.epayment}/#/history`
          if (!window.hasOwnProperty('cordova')) {
            window.location.href = page
            return
          }
          cordova.InAppBrowser.open(page, '_system', 'location=no,enableViewportScale=yes,zoom=no')
        }
      }
    }
  }
</script>

<style>
body {
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
}
.footer {
  /* Apply this to v-bottom-nav if necessary. */
  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
}
</style>
